import useBodyClass from '@hooks/useBodyClass'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { UserContext } from '../context/UserContext'
import { createAlert, userAlerts } from '../lib/api-services/authService'
import { createFavouriteFromLocalstore } from '../lib/helpers'
import { Router } from '../routes'
import { useRouter } from 'next/router'

const CreateAccountForm = dynamic(
  () => import('../components/CreateAccount/CreateAccountForm'),
  { ssr: false }
)

const CreateAccount = dynamic(
  () => import('../components/CreateAccount/CreateAccount'),
  { ssr: false }
)

const CreateAccountPage = (props) => {
  const router = useRouter()
  const { pageData } = props
  const [emailSignup, setEmailSignup] = useState(router.query?.signup === 'email')
  const links = {
    facebook: {
      label: 'Login With facebook',
      onClick: () => loginAndRedirect,
    },
    google: {
      label: 'Login With Google',
      onClick: () => loginAndRedirect,
    },
    email: {
      label: 'Register with Email',
      onClick: () => handleEmailClick,
    },
    login: {
      label: 'Login',
      url: '/login/',
    },
  }

  useBodyClass('modal-open', false)

  const loginAndRedirect = async ({ token, user }) => {
    const { setToken, setProfile, setAlerts, returnto } = props
    await setToken(token)
    await setProfile(user)

    /*
      Create alert from localstorage data if have
    */
    const params = localStorage.getItem('saveSearchParams')
    if (params) {
      const alertResponse = await createAlert(token, JSON.parse(params))
      if (!alertResponse.error) {
        const alertResponse = await userAlerts(token)
        setAlerts(alertResponse.results)
      }
      localStorage.removeItem('saveSearchParams')
    }
    await createFavouriteFromLocalstore(token)

    if (Router.router.query.redirect) {
      Router.pushRoute(Router.router.query.redirect)
    } else if (user && user.subscriber) {
      if (returnto && returnto.path)
        Router.pushRoute(returnto.path).then(
          () => window && window.scrollTo(0, 0)
        )
      else Router.pushRoute('/my-account')
    }
  }

  const handleEmailClick = () => {
    setEmailSignup(true)
    Router.pushRoute(`/create-account/?signup=email`, { shallow: true })
  }

  useEffect(() => {
    if (emailSignup) {
      document.body.classList.add('active-nav')
    } else {
      document.body.classList.remove('active-nav')
    }
  }, [emailSignup])

  useEffect(() => {
    if (router.query?.signup === 'email') {
      setEmailSignup(true)
    } else {
      setEmailSignup(false)
    }
  }, [router.query?.signup])

  return emailSignup ? (
    <CreateAccountForm />
  ) : (
    <CreateAccount pageData={pageData} links={links} />
  )
}

const ContextWrappedCreateAccountPage = (props) => (
  <UserContext.Consumer>
    {(context) => <CreateAccountPage {...props} {...context} />}
  </UserContext.Consumer>
)

export default ContextWrappedCreateAccountPage
